<template>
  <div class="max-w-2xl mx-auto py-8 px-4">
    <h2 class="text-2xl font-bold mb-6">Faites votre choix</h2>

    <div class="space-y-4">
      <div
        role="button"
        tabindex="0"
        :aria-pressed="selectedChoice === 'accepted'"
        class="p-6 border-2 rounded-lg cursor-pointer transition-colors"
        :class="selectedChoice === 'accepted' ? 'border-primary' : 'border-gray-200 hover:border-gray-300'"
        @click="$emit('select-choice', 'accepted')"
        @keydown.enter.space.prevent="$emit('select-choice', 'accepted')"
      >
        <div class="flex items-center gap-3">
          <div
            class="w-5 h-5 rounded-full border-2 flex items-center justify-center"
            :class="selectedChoice === 'accepted' ? 'border-primary' : 'border-gray-300'"
          >
            <div v-if="selectedChoice === 'accepted'" class="w-3 h-3 rounded-full bg-primary" />
          </div>
          <h3 class="text-lg font-semibold">Je poursuis mon contrat</h3>
        </div>
        <p class="text-gray-600 text-sm mt-2 ml-8">
          J'accepte les nouvelles conditions et je souhaite continuer à être couvert par Acheel.
        </p>
      </div>

      <div
        role="button"
        tabindex="0"
        :aria-pressed="selectedChoice === 'refused'"
        class="p-6 border-2 rounded-lg cursor-pointer transition-colors"
        :class="selectedChoice === 'refused' ? 'border-primary' : 'border-gray-200 hover:border-gray-300'"
        @click="$emit('select-choice', 'refused')"
        @keydown.enter.space.prevent="$emit('select-choice', 'refused')"
      >
        <div class="flex items-center gap-3">
          <div
            class="w-5 h-5 rounded-full border-2 flex items-center justify-center"
            :class="selectedChoice === 'refused' ? 'border-primary' : 'border-gray-300'"
          >
            <div v-if="selectedChoice === 'refused'" class="w-3 h-3 rounded-full bg-primary" />
          </div>
          <h3 class="text-lg font-semibold">Je résilie mon contrat</h3>
        </div>
        <p class="text-gray-600 text-sm mt-2 ml-8">
          Je ne souhaite pas poursuivre mon contrat sous les nouvelles conditions.
        </p>
      </div>
    </div>

    <div v-if="selectedChoice === 'refused'" class="mt-4">
      <Alert type="info">
        <template #title>Une hésitation ?</template>
        Vous pouvez revenir sur votre décision dans un délai de 15 jours en nous contactant à contact@estaly.co.
      </Alert>
    </div>

    <div v-if="selectedChoice" class="mt-4">
      <PrimaryButton v-if="selectedChoice === 'accepted'" :loading="loading" @click="$emit('confirm', 'accepted')">
        CONFIRMER LA POURSUITE
      </PrimaryButton>
      <button
        v-else
        type="button"
        class="border-2 border-red-500 text-red-500 font-semibold px-6 py-2 rounded-lg hover:bg-red-50 transition-colors"
        :disabled="loading"
        @click="$emit('confirm', 'refused')"
      >
        CONFIRMER LA RÉSILIATION
      </button>
    </div>

    <div class="mt-8">
      <SecondaryButton @click="$emit('previous')">PRÉCÉDENT</SecondaryButton>
    </div>
  </div>
</template>

<script>
import { Alert, PrimaryButton, SecondaryButton } from "@estaly/ui";

export default {
  components: { Alert, PrimaryButton, SecondaryButton },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    selectedChoice: {
      type: String,
      default: null,
    },
  },

  emits: ["confirm", "previous", "select-choice"],
};
</script>
